import { PatientMedicine, PatientMedicineQuery } from '@dreryk/egabinet-prescription-frontend-api';

import {
   LazyLoadedDataConfigurationByCqrsQuery,
   useLazyLoadedDataConfigurationByCqrsQuery,
} from '@dreryk/drerykweb-main-frontend';
import { Ordering } from '@dreryk/react-common';

import { COMMERCIAL_MEDICINE_NAME_COLUMN } from '../MedicineSelectorTable.hooks';

// TODO: DREGAB-1669 set valid type when mechanism to sort on custom fields will be available
const DEFAULT_ORDERINGS: Ordering<any>[] = [
   {
      property: COMMERCIAL_MEDICINE_NAME_COLUMN,
      descending: false,
   },
];

export const useFavoriteMedicinesSelectorConfiguration = (
   patientId: number
): LazyLoadedDataConfigurationByCqrsQuery<PatientMedicine> => {
   return useLazyLoadedDataConfigurationByCqrsQuery<PatientMedicine>(() => {
      const patientMedicineQuery = new PatientMedicineQuery();
      patientMedicineQuery.patientId = patientId;
      patientMedicineQuery.favorite = true;
      return patientMedicineQuery;
   }, DEFAULT_ORDERINGS);
};
